import { Spacer } from '@sparemin/blockhead';
import React from 'react';
import { SubscriptionPeriod } from 'blocks/Pricing/types';
import GradientBadge from 'components/GradientBadge';
import useConnectedModal from 'containers/ConnectedModal/useConnectedModal';
import { BillingCyclePlanOptions } from './BillingCycleOptions';
import useBillingCycleCosts from './useBillingCycleCosts';
import { block } from './utils';

export interface BillingCycleModalCostProps {
  planOptions: BillingCyclePlanOptions;
  period: SubscriptionPeriod;
  showLimitedTimeBadge?: boolean;
  showPreviousCost?: boolean;
}

const BillingCycleModalCost: React.FC<BillingCycleModalCostProps> = ({
  planOptions,
  period,
  showLimitedTimeBadge,
  showPreviousCost,
}) => {
  const { params } = useConnectedModal('AddBillingCycle');
  const { tier, subtier } = params ?? {};

  const { cost, previousCost } = useBillingCycleCosts({
    planOptions,
    period,
    tier,
    subtier,
  });

  return (
    <Spacer space="8px" align="center" justify="center">
      {showLimitedTimeBadge && <GradientBadge contents="Limited time" />}

      {showPreviousCost && (
        <span className={block('old-cost')}>{`${previousCost} / mo`}</span>
      )}

      <div className={block('cost')}>{`${cost} / ${
        period === 'yearly' ? 'year' : 'mo'
      }`}</div>
    </Spacer>
  );
};

export default BillingCycleModalCost;
